/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faMinus,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import timezones from "../Builder/nodes/Logic/timezones";
import "react-phone-number-input/style.css";
import { isUserPermitted, pageProps } from "../helpers/pageProps";

export default function ContactField({
  contactField,
  contact,
  handleChange,
  errors,
}) {
  const { countries } = pageProps;
  const contactDetails = Array.isArray(contact?.details) ? contact.details : [];

  return (
    <div key={contactField.uuid} className="bg-white p-2 px-3 rounded-3">
      <div className="row align-items-center">
        <span className="fw-semibold my-2">
          <span className="fs-4">{contactField.label}</span>
          {contactField.isPrimary > 0 ? (
            <span
              className="badge bg-secondary ms-2"
              title="This field is used as the primary identifier for the contact."
            >
              Primary
            </span>
          ) : null}
          {contactField.minItemsRequired > 0 ? (
            <span
              className="badge bg-secondary ms-2"
              title={`At least ${contactField.minItemsRequired || 1} ${
                contactField.minItemsRequired > 1 ? "values are" : "value is"
              } required.`}
            >
              <FontAwesomeIcon
                className="me-1"
                icon={faExclamationTriangle}
              />
              Required {contactField.minItemsRequired > 1 ? `(${contactField.minItemsRequired})` : ""}
            </span>
          ) : null}
        </span>
        {contactField.isMultiple && !contactField.isSelect && (
          <>
            <div className="col text-end">
              <button
                type="button"
                title="Add input"
                className="btn btn-link btn-sm border-0"
                onClick={() =>
                  handleChange({
                    contactField,
                    values: [
                      ...(contactDetails
                        .find(
                          (detail) => detail.field.uuid === contactField.uuid
                        )
                        ?.values?.map((v) => v.data) || []),
                      "",
                    ],
                  })
                }
              >
                <FontAwesomeIcon icon={faPlus} /> Add
              </button>
            </div>
            <div className="col-12 p-2" />
          </>
        )}
        {!contactField.isSelect && contactField.isMultiple ? (
          <>
            {(
              contactDetails
                .find((detail) => detail.field.uuid === contactField.uuid)
                ?.values?.map((v) => v.data) || []
            ).map((v, i, values) => (
              <div key={i} className=" d-flex align-items-center">
                <div className="flex-grow-1 mb-1">
                  <Input
                    dateTimeType={contactField.dateTimeType}
                    inputType={
                      contactField.isDateTime ? "dateTime" : "textArea"
                    }
                    value={[v]}
                    onChange={(vs) =>
                      handleChange({
                        contactField,
                        values: [
                          ...values.slice(0, i),
                          vs[0],
                          ...values.slice(i + 1),
                        ],
                      })
                    }
                  />
                </div>

                {contactField.isMultiple && (
                  <button
                    type="button"
                    title="Remove input"
                    className="btn btn-sm btn-outline-secondary border-0 float-end"
                    onClick={() =>
                      handleChange({
                        contactField,
                        values: [...values.slice(0, i), ...values.slice(i + 1)],
                      })
                    }
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </button>
                )}
              </div>
            ))}
          </>
        ) : (
          <div className="col">
            <Input
              dateTimeType={contactField.dateTimeType}
              isMulti={contactField.isMultiple}
              inputType={
                contactField.isSms || contactField.isVoice
                  ? "phone"
                  : contactField.isDateTime
                  ? "dateTime"
                  : contactField.isSelect
                  ? "select"
                  : undefined
              }
              isValidNewOption={(v) => contactField.isMultiple && v}
              options={[
                ...(!contactField.selectType
                  ? contactField.options?.map((o) => ({
                      value: o.uuid,
                      label: o.label,
                    })) ?? []
                  : []),
                ...(contactField.selectType === "country"
                  ? countries.map((c) => ({
                      value: c.country_code,
                      label: c.country_name,
                    }))
                  : []),
                ...(contactField.selectType === "time-zone"
                  ? timezones.map((tz) => ({
                      value: tz.tzCode,
                      label: tz.label,
                    }))
                  : []),
              ]}
              value={
                contactDetails
                  .find((detail) => detail.field.uuid === contactField.uuid)
                  ?.values?.map((v) => v.data) || []
              }
              onChange={(values) =>
                handleChange({
                  contactField,
                  values,
                })
              }
            />
          </div>
        )}
      </div>
      <div className="text-secondary">
        {errors
          .find((error) => error.fieldUuid === contactField.uuid)
          ?.messages.map((message) => (
            <div>
              {message.replace("rpc error: code = InvalidArgument desc = ", "")}
            </div>
          ))}
        {contactField.isHidden && !isUserPermitted("sensitive_data")
          ? "You do not have permission to view this field."
          : ""}
      </div>
    </div>
  );
}
